:root {
  --brand-50: #eef4ff;
  --brand-500: #0052ff;
  --brand-600: #0047e0;
  --brand-700: #003ecc;

  --gray-25: #fcfcfd;
  --gray-50: #f7f7f7;
  --gray-100: #eef0f3;
  --gray-200: #dee1e6;
  --gray-300: #c9cdd4;
  --gray-400: #a8acb3;
  --gray-500: #7c828a;
  --gray-600: #5b616e;
  --gray-700: #323741;
  --gray-800: #16181c;
  --gray-900: #0a0b0d;

  --success-500: #05b169;
  --danger-500: #cf202f;
  --warning-500: #f4b000;
  --info-500: #0052ff;
  --aws-orange: #ff9900;

  --white: #ffffff;

  --font-family-base: 'Outfit', 'Pretendard', 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --font-size-sm: 0.875rem;
  --font-size-base: 1rem;
  --font-size-lg: 1.125rem;
  --font-size-xl: 1.25rem;
  --font-size-2xl: 1.75rem;

  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;

  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 24px;
  --radius-pill: 999px;

  --shadow-xs: 0 1px 2px rgba(10, 11, 13, 0.04);
  --shadow-sm: 0 1px 3px rgba(10, 11, 13, 0.06);
  --shadow-md: 0 8px 24px rgba(10, 11, 13, 0.08);
  --shadow-lg: 0 18px 48px rgba(10, 11, 13, 0.12);

  --header-height: 64px;
  --sidebar-width: 300px;
  --sidebar-collapsed-width: 80px;
}

* {
  box-sizing: border-box;
}

html,
body,
#root {
  margin: 0;
  width: 100%;
  min-height: 100%;
}

body {
  font-family: var(--font-family-base);
  font-size: var(--font-size-base);
  line-height: 1.55;
  color: var(--gray-800);
  background: var(--gray-50);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

button,
input,
select,
textarea {
  font: inherit;
}

a {
  color: inherit;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--gray-100);
}

::-webkit-scrollbar-thumb {
  background: var(--gray-300);
  border-radius: 999px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--gray-400);
}
